import React from "react";
import AnimatedButton from "./AnimatedButton";

const DownloadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="ml-1 mr-2 inline-block"
    width="24"
    height="24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
    />
  </svg>
);

export default function DownloadButtons() {
  return (
    <div>
      <AnimatedButton
        href="/cv-fialon-dev-js-aout-2026.pdf"
        ariaLabel="Télécharger mon CV"
        target="_blank"
        rel="noreferrer noopener"
        className="py-2 px-2 mr-2 bg-rose text-white rounded-full hover:bg-bleuciel hover:text-white transition delay-150 duration-300"
        svg={<DownloadIcon />}>
        Mon CV
      </AnimatedButton>
      <AnimatedButton
        href="/dossier_professionnel_devops-fialon-compress.pdf"
        ariaLabel="Télécharger mon dossier pro DevOps"
        target="_blank"
        rel="noreferrer noopener"
        className="py-2 px-2 bg-rose text-white rounded-full hover:bg-bleuciel hover:text-white transition delay-150 duration-300"
        svg={<DownloadIcon />}>
        Dossier pro DevOps
      </AnimatedButton>
    </div>
  );
}
